import { useState } from "react";

const useSubmit = () => {
  const [isSubmiting, setIsSubmiting] = useState(false);

  const submit = async (callback) => {
    if (isSubmiting) {
      return;
    }
    setIsSubmiting(true);
    try {
    const response = await callback();
    setIsSubmiting(false);
    return response
    } catch (e){
      setIsSubmiting(false);
      throw e;
    }
  }
  return {submit, isSubmiting};
};

export default useSubmit;
